import FunctionPanel from '../components/FunctionPanel';

const UPLOAD_FIELDS = [
    { key: 'source', label: '源素材', required: true },
];

const SkinHDPanel = (props) => (
    <FunctionPanel
        panelKey="skinHD"
        uploadFields={UPLOAD_FIELDS}
        advancedOptions={{
            showOrientation: false,
            showExpression: false,
            showKeepHeadwear: false,
            includeOrientationParam: false,
            includeExpressionParam: false,
            includeKeepHeadwearParam: false,
            includeSkipSelectParam: false,
            uploadParamKeyMap: {
                source: 'srcImage',
            },
            extraSelectFields: [
                {
                    key: 'hd_area',
                    label: '高清区域',
                    options: [
                        { value: 0, label: '人脸' },
                        { value: 1, label: '全身皮肤' },
                    ],
                    defaultValue: 0,
                },
                {
                    key: 'mode',
                    label: '模式',
                    options: [
                        { value: 0, label: '更美化' }, 
                        { value: 1, label: '更真实' },
                    ],
                    defaultValue: 0,
                },
            ],
            extraSwitchFields: [
                {
                    key: 'shine',
                    label: '去油光',
                    defaultValue: 0,
                    checkedValue: 1,
                    uncheckedValue: 0,
                    disabled: ({ extraSelectValues }) => Number(extraSelectValues.mode) !== 0,
                    resetWhenDisabled: true,
                    resetValue: 0,
                },
            ],
        }}
        {...props}
    />
);

export default SkinHDPanel;
